export const roundNumbers = (n: string | number | null | undefined, down?: boolean) => {
  switch (typeof n) {
    case 'number':
      return down ? Math.floor(n * 100) / 100 : Math.round(n * 100) / 100;
    case 'string':
      return down ? Math.floor(parseFloat(n) * 100) / 100 : Math.round(parseFloat(n) * 100) / 100;
    default:
      return 0;
  }
};

export const roundUpToNearestUnit = (num: number, unit: number) => {
  return Math.ceil(num / unit) * unit;
}

export const formatRoundedNumber = (n: string | number | null | undefined): number => {
  if (n == null || n === '') return 0;

  const num = typeof n === 'number' ? n : parseFloat(n);
  if (isNaN(num)) return 0;

  const rounded = Math.round(num * 100) / 100;
  return parseFloat(rounded.toString()); // removes trailing zeros like .00
};
